/* eslint-disable max-len */
import { WaveShapeEnum } from '@/enum/WaveShapeEnum';

import type { HeroSectionType } from '@/components/blocks/HeroSection/HeroSectionType';

/** Forme utilisée pour le path SVG du fond (wavy → convex, non géré en SVG dédié). */
export type HeroBackgroundSvgShape = typeof WaveShapeEnum.CONVEX | typeof WaveShapeEnum.CONCAVE;

export interface HeroBackgroundSvgConfig {
  /** Path initial (1er keyframe de l’animation). */
  d: string;
  /** Valeurs SMIL `animate` (keyframes séparés par `;`). */
  animateValues: string;
  dur: number;
  keySplines: string;
}

const CONVEX: HeroBackgroundSvgConfig = {
  d: 'M -0.00000429153 -0.00323486 L 1512 -0.00323486 L 1512 796.811 C 1512 796.811 1241.5 877.545 883.998 862.016 C 465.998 843.862 -0.00000429153 618.86 -0.00000429153 618.86 L -0.00000429153 -0.00323486 Z',
  animateValues:
    'M -0.000004291529876354616 -0.003234860021620989 L 1512 -0.003234860021620989 L 1512 796.8109741210938 C 1512 796.8109741210938 1241.5 877.5449829101562 883.9979858398438 862.0159912109375 C 465.99798583984375 843.8619995117188 -0.000004291529876354616 618.8599853515625 -0.000004291529876354616 618.8599853515625 L -0.000004291529876354616 -0.003234860021620989 Z; M -0.000004291529876354616 -0.003234860021620989 L 1512 -0.003234860021620989 L 1512 796.8109741210938 C 1512 796.8109741210938 1576.449951171875 867.6749877929688 872.791015625 858.7130126953125 C 466.49200439453125 850.5560302734375 -0.000004291529876354616 756.3599840402603 -0.000004291529876354616 756.3599840402603 L -0.000004291529876354616 -0.003234860021620989 Z; M -0.000004291529876354616 -0.003234860021620989 L 1512 -0.003234860021620989 L 1512 796.8109741210938 C 1512 796.8109741210938 1241.5 877.5449829101562 883.9979858398438 862.0159912109375 C 465.99798583984375 843.8619995117188 -0.000004291529876354616 618.8599853515625 -0.000004291529876354616 618.8599853515625 L -0.000004291529876354616 -0.003234860021620989 Z',
  dur: 10,
  keySplines: '0 0 1 1;0 0 1 1',
};

/** Concave : animation 3 états (extrait du gabarit historique du bloc). */
const CONCAVE: HeroBackgroundSvgConfig = {
  d: 'M0,0H1512V826.14s-270.5-81-628-93.76C466,717.45,0,864,0,864Z',
  animateValues:
    'M0,0H1512V826.14s-270.5-81-628-93.76C466,717.45,0,864,0,864Z;M0,0H1512V826.14s-702-125-1061-98C143,759.18,0,864,0,864Z;M0,0H1512V826.14s-270.5-81-628-93.76C466,717.45,0,864,0,864Z',
  dur: 5,
  keySplines: '0 0 1 1;0 0 1 1',
};

const BY_SVG_SHAPE: Record<HeroBackgroundSvgShape, HeroBackgroundSvgConfig> = {
  [WaveShapeEnum.CONVEX]: CONVEX,
  [WaveShapeEnum.CONCAVE]: CONCAVE,
};

/**
 * Résout la config SVG du fond : concave si choisi, sinon convex (y compris pour `wavy`).
 */
export function getHeroBackgroundSvgConfig(shape: HeroSectionType['shape']): HeroBackgroundSvgConfig {
  if (shape === WaveShapeEnum.CONCAVE) {
    return BY_SVG_SHAPE[WaveShapeEnum.CONCAVE];
  }

  return BY_SVG_SHAPE[WaveShapeEnum.CONVEX];
}
